import React from "react";
import { Button } from "react-bootstrap";
export default function CustomButton({
  variant,
  type = "button",
  className,
  isDisabled = false,
  label,
  onClick = () => {},
  isLoading,
  children,
}) {
  return (
    <Button
      variant={variant}
      type={type}
      className={className}
      disabled={isDisabled || isLoading}
      onClick={onClick}
    >
     {children}
    </Button>
  );
}
